import { Badge, Box, Divider, Flex, Grid, Text } from "@mantine/core";
import { green } from "../../const/variables";

const ExportVAT = ({ data, code }: { data: string; code: string }) => {
  const dataView = JSON.parse(data);

  return (
    <Box m={15} w={310}>
      <Flex justify={"center"} w={"100%"}>
        <Badge color={green.base} radius="sm" variant="dot" size="md">
          {code}
        </Badge>
      </Flex>
      <Divider
        label="Thông tin xuất hóa đơn VAT"
        labelPosition="center"
        my={"xs"}
      />
      <Flex align={"center"} gap={"md"} w={"100%"}>
        <Flex direction={"column"} gap={"xs"} w={"100%"}>
          <Grid w={"100%"}>
            <Grid.Col span={{ base: 12, md: 12, lg: 3.5 }}>
              <Text size="md" fw={500}>
                Mã số thuế:
              </Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 12, lg: 8.5 }}>
              <Text size="md">
                {dataView?.TaxCode ? dataView?.TaxCode : "Không có dữ liệu !"}
              </Text>
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, md: 12, lg: 3.5 }}>
              <Text size="md" fw={500}>
                Tên công ty:
              </Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 12, lg: 8.5 }}>
              <Text size="md">
                {dataView?.TaxCompany
                  ? dataView?.TaxCompany
                  : "Không có dữ liệu !"}
              </Text>
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, md: 12, lg: 3.5 }}>
              <Text size="md" fw={500}>
                Địa chỉ:
              </Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 12, lg: 8.5 }}>
              <Text size="md">
                {dataView?.TaxAddress
                  ? dataView?.TaxAddress
                  : "Không có dữ liệu !"}
              </Text>
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, md: 12, lg: 3.5 }}>
              <Text size="md" fw={500}>
                Email:
              </Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 12, lg: 8.5 }}>
              <Text size="md">
                {dataView?.TaxEmail ? dataView?.TaxEmail : "Không có dữ liệu !"}
              </Text>
            </Grid.Col>
          </Grid>
        </Flex>
      </Flex>
    </Box>
  );
};

export default ExportVAT;
